import { UserRejectedRequestError } from 'viem';
import { AgeVerificationError, WalletAlreadyLinkedError } from '../types/errors';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapErrorMessage = (error: any, errorsMap: Map<string, string> = new Map(), defaultErrorMessage = 'Something went wrong') => {
  if (error instanceof UserRejectedRequestError) {
    return errorsMap.get('TERMS_NOT_SIGNED');
  }

  if (error instanceof AgeVerificationError) {
    return errorsMap.get('AGE_VERIFICATION_ERROR');
  }

  if (error instanceof WalletAlreadyLinkedError) {
    return errorsMap.get('WALLET_ALREADY_LINKED');
  }

  return errorsMap.get(error?.response?.data?.error?.message)
    || error?.response?.data?.error?.message
    || errorsMap.get(error?.response?.data?.error?.code)
    || defaultErrorMessage;
};
